document.querySelector('.oforml__sposobShop').addEventListener('click', function (e) {
  document.querySelector(".modalShop").classList.add('active')
})

document.querySelector('.modalShop__close').addEventListener('click', function (e) {
  document.querySelector(".modalShop").classList.remove('active')
})

document.querySelectorAll('[data-item]').forEach(item => {
  item.addEventListener('click', function (e) {
    this.classList.add('active')
    document.querySelector('.modalShop__list').classList.add('active')
    document.querySelector('.modalShop__btnsUpr').classList.add('active')
  })
})

document.querySelector('.modalShop__back--list').addEventListener('click', function(e){
    document.querySelector('.modalShop__list').classList.remove('active')
    document.querySelector('.modalShop__btnsUpr').classList.remove('active')
    document.querySelector('[data-item].active').classList.remove('active')
})

document.querySelector('.modalShop__back--map').addEventListener('click', function(e){
  document.querySelector('.modalShop__list').classList.remove('active')
  document.querySelector('.modalShop__btnsUpr').classList.remove('active')
  document.querySelector('[data-item].active').classList.remove('active')
  document.querySelector('.modalShop__left').classList.remove('act')
})

document.querySelector(".modalShop__btnEnter").addEventListener("click", function(e){
    document.querySelector('.modalShop').classList.remove('active')
})

document.querySelector('[data-switch="map"]').addEventListener('click',function(e){
  document.querySelector('.modalShop__left').classList.add('map')
  document.querySelector('[data-switch="list"]').classList.remove('active')
  this.classList.add('active')
})

document.querySelector('[data-switch="list"]').addEventListener('click',function(e){
  document.querySelector('.modalShop__left').classList.remove('map')
  document.querySelector('[data-switch="map"]').classList.remove('active')
  this.classList.add('active')
})

// document.querySelector('.modalShop__map').addEventListener('click', function(e){
//   console.log(123)
//   document.querySelector('.modalShop__left').classList.add('act')
//   document.querySelector('[data-item="4"]').click()
// })

ymaps.ready(init);
function init() {
  document.querySelectorAll(".modalShop__map").forEach((mapElement) => {
    // Создание карты.
    var myMap = new ymaps.Map(mapElement, {
      // Координаты центра карты.
      // Порядок по умолчанию: «широта, долгота».
      // Чтобы не определять координаты центра карты вручную,
      // воспользуйтесь инструментом Определение координат.
      center: [55.76, 37.64],
      // Уровень масштабирования. Допустимые значения:
      // от 0 (весь мир) до 19.
      zoom: 10,
    });

    const placemarkArray = [
      {
        id:1, 
        coords: [55.75, 37.61]
      },
      {
        id:4, 
        coords: [55.55, 37.41]
      },
      {
        id:5, 
        coords: [55.65, 37.51]
      }
    ];
    const myGeoObjects = [];

    placemarkArray.forEach((el) => {
      const placemark = new ymaps.Placemark(
        el.coords,
        {},
        {
          // iconLayout: "default#image",
          // iconImageHref: "/img/map/placemark.svg",
          iconImageSize: [30, 42],
          iconImageOffset: [-3, -42],
          hasBalloon: false,
        }
      );
      placemark.events.add(["click"], function () {
        document.querySelector('.modalShop__left').classList.add('act')
        document.querySelectorAll('[data-item]').forEach(item=>{
          item.classList.remove('active')
        })
        document.querySelector(`[data-item="${el.id}"]`).click()
      });
      myGeoObjects.push(placemark);
    });

    var clusterIcons = [
      {
        href: "",
        size: [24, 24],
        // Отступ, чтобы центр картинки совпадал с центром кластера.
        offset: [-12, -12],
      },
    ];

    const MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
      '<div style="width: 24px; height: 24px; border-radius: 50%; color: ##1E1E1E; background: #F9D548; font-weight: 800; font-size:14px; line-height:14px; border: 2px solid #1E1E1E; display: flex; align-items: center; justify-content: center;">{{ properties.geoObjects.length }}</div>'
    );
    // Создание кластера и запрещение масштабирования карты при щелчке по кластеру
    const clusterer = new ymaps.Clusterer({
      clusterIcons,
      clusterDisableClickZoom: true,
      clusterIconContentLayout: MyIconContentLayout,
    });
    clusterer.add(myGeoObjects);
    myMap.geoObjects.add(clusterer);
  });
}

const addressItems = document.querySelectorAll(
  ".productCardFull__mapAddressItem"
);
addressItems.forEach((item) => {
  item.addEventListener("click", () => {
    if (!item.classList.contains("active")) {
      addressItems.forEach((el) => el.classList.remove("active"));
      item.classList.add("active");
    }
  });
});